import React, { FC } from 'react'

import { Navigate } from 'react-router-dom'
import { Routes } from 'common/constants'

import { TErrorHandlerView } from '../types/ErrorHandler.types'

export const ErrorHandlerView: FC<TErrorHandlerView> = ({ to, goTo, replace }) => (
  <Navigate to={to ?? Routes.ERROR} state={{ goTo: goTo ?? Routes.ROOT }} replace={replace} />
)
